import { Fragment } from 'react'
import { GetStaticProps, GetStaticPropsContext, NextPage } from 'next'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

import TutorOnDemandPhysics from '~/tutor-on-demand/pages/TutorOnDemandPhysics.page'
import { COMMON_TRANSLATION_MODULE_NAMES, DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES } from '~/shared/layouts/constants'
import { DefaultLayout } from '~/shared/layouts/DefaultLayout'
import SubjectMetatags, { SubjectType } from '~/components/Metadata/SubjectMetatags'

const TutorOnDemandPhysicsPage: NextPage = () => {
  const { t } = useTranslation('tutorOnDemandPhysics')
  const title = t('title')

  return (
    <Fragment>
      <SubjectMetatags metaDescription={t('metaDescription')} title={title} type={SubjectType.PHYSICS} />

      <DefaultLayout zeroPadding>
        <TutorOnDemandPhysics type={SubjectType.PHYSICS} />
      </DefaultLayout>
    </Fragment>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }: GetStaticPropsContext) => ({
  props: {
    ...(await serverSideTranslations(locale as string, [
      ...DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES,
      ...COMMON_TRANSLATION_MODULE_NAMES,
      'tutorOnDemand',
      'tutorOnDemandPhysics',
    ])),
  },
})

export default TutorOnDemandPhysicsPage
